<template>
  <div id="fileupload">
    <FilePond  
        allow-multiple="false" 
        :allowPaste="true"
        v-on:init="handleFilePondInit"
        v-on:updatefiles="handleFilePondUpdateFile"
    />
  </div>
</template>
<script>
import vueFilePond from 'vue-filepond';
import '../../../assets/css/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import '../../../assets/css/filepond-plugin-image-preview.min.css';

export default {
    name: 'fileupload',
    components: {
        FilePond: vueFilePond(FilePondPluginImagePreview)
    },
    data() {
        return {
            myFiles:[],
        }
    },
    methods: {
        handleFilePondInit () {
            // FilePond instance methods are available on `this.$refs.pond`
        },
        onload (e, r) {
            console.log(r)
        },
        
        handleFilePondUpdateFile(files){
            console.log('img')
            console.log(files)
            this.myFiles = files.map(files => files.file);
            this.$emit('imgFileHandler', this.myFiles);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/views/Common/image-upload/editorImgUpload.vue